
import { Component, Input, OnInit} from '@angular/core';
import { IContractStateContext } from '../state-context/state-context.interface';
import { IContractState } from '../state.interface';
// -----------------------------------------------------------------------------------------
@Component({
  templateUrl: './initial.state.html'
})
export class InitialStateComponent implements IContractState, OnInit {
  @Input() context!: IContractStateContext;
  // -----------------------------------------------------------------------------------------
  ngOnInit(): void {
    //setTimeout(() => this.context.setGeneratedState(), 2000);
  }
  // -----------------------------------------------------------------------------------------
  nextState() {
    this.context.setInitialState();
  }
  // -----------------------------------------------------------------------------------------
} 
